module.exports = __webpack_public_path__ + "static/img/zm.05da5ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/zm.jpg
// module id = fxn4
// module chunks = 14